import React from "react";
import NavBar from "../Components/Navbar";

const NN = () => {
  return (
    <div>
      <NavBar />
      <div
        style={{
          height: "1000px",
        }}
      ></div>
    </div>
  );
};

export default NN;
